import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "salesChannel",
  standalone: true,
})
export class SalesChannelPipe implements PipeTransform {
  transform(value: string): string {
    switch (value) {
      case "online":
        return "Venda Web";
      case "affiliate":
        return "Venda App Mobile";
      case "pdv":
        return "PDV Físico";
      default:
        return value;
    }
  }
}
